export const DECLINE_GROUP_CREATION_REQUEST = 'DECLINE_GROUP_CREATION_REQUEST';
export const APPROVE_GROUP_CREATION_REQUEST = 'APPROVE_GROUP_CREATION_REQUEST';

export const OPEN_DELETE_GROUP_REQUEST_DIALOG =
  'OPEN_DELETE_GROUP_REQUEST_DIALOG';
export const DECLINE_GROUP_REQUEST_DIALOG = 'DECLINE_GROUP_REQUEST_DIALOG';
export const DELETE_GROUP_REQUEST_DIALOG = 'DELETE_GROUP_REQUEST_DIALOG';
